import axios from "./axios";

const getCountries = () => {
    return axios.get('/address/countries', {
        params: {lang: 'ru'}
    })
}

const getRegions = () => {
    return axios.get('/address/children', {
        params: {parent: 4948}
    })
}

const getChildren = (parent) => {
    return axios.get('/address/children', {
        params: {parent: parent}
    })
}

const getStreet = (ate) => {
    return axios.get('/address/street/list', {
        params: {ate: ate}
    })
}

const saveAddress = (data) => {
    return axios.post('/address/new', data)
        .then(response => response.data);
}

const getAddress = id => {
    return axios.get(`/address/show/${id}`)
        .then(response => response.data)
}

export default {
    getCountries,
    getRegions,
    getChildren,
    getStreet,
    saveAddress,
    getAddress
}
